import { create } from 'zustand';
import { makeGet, makePatch, makePost } from '../../utils/call-api-endpoint';
import type { PaginatedList } from '../common/padinated-list';
import {
  toQueryString,
  type PaginationQueryParamsWithStatus
} from '../common/pagination-query-params';
import { useUIStore } from '../ui/ui.store';
import type { Unidad } from './unidad';

export interface UnidadesState {
  list: PaginatedList<Unidad>;
  current: Unidad;
  actives: Unidad[];

  nuevo: () => void;
  cargarPaginadas: (params: PaginationQueryParamsWithStatus) => Promise<void>;
  cargarActivas: () => Promise<void>;
  cargarPorId: (id: string) => Promise<void>;
  registrar: (request: RegistrarUnidad) => Promise<boolean>;
  actualizar: (id: string, request: ActualizarUnidad) => Promise<boolean>;
  activar: (id: string) => Promise<boolean>;
  desactivar: (id: string) => Promise<boolean>;
}

export interface RegistrarUnidad {
  nombre: string;
  soloEnteros: boolean;
}

export interface ActualizarUnidad {
  nombre: string;
  soloEnteros: boolean;
}

// const delay = () => new Promise((resolve) => setTimeout(resolve, 1000));
const { showSuccessToast } = useUIStore.getState();

export const useUnidadesStore = create<UnidadesState>()((set, get) => ({
  list: {
    items: [],
    pageIndex: 0,
    pageSize: 10,
    totalRows: 0
  },
  current: {} as Unidad,
  actives: [],

  nuevo: () =>
    set({
      current: {} as Unidad
    }),
  cargarPaginadas: async (params: PaginationQueryParamsWithStatus) => {
    const data = await makeGet<PaginatedList<Unidad>>(
      `/unidades/paginadas?${toQueryString(params)}`
    );

    if (data.isFailure) return;

    set({
      list: data.result
    });
  },
  cargarActivas: async () => {
    const data = await makeGet<Array<Unidad>>('/unidades/activas');

    if (data.isFailure) return;

    set({
      actives: data.result
    });
  },
  cargarPorId: async (id: string) => {
    const data = await makeGet<Unidad>(`/unidades/${id}`);

    if (data.isFailure) return;

    set({
      current: data.result
    });
  },
  registrar: async (request: RegistrarUnidad) => {
    const data = await makePost<RegistrarUnidad, Unidad>('/unidades/', request);

    if (data.isFailure) return false;

    showSuccessToast('Registro agregado');

    set({
      current: {} as Unidad
    });

    return true;
  },
  actualizar: async (id: string, request: ActualizarUnidad) => {
    const data = await makePatch<ActualizarUnidad, Unidad>(`/unidades/${id}`, request);

    if (data.isFailure) return false;

    showSuccessToast('Registro actualizado');

    set({
      current: {
        ...get().current,
        ...request
      }
    });

    return true;
  },
  activar: async (id: string) => {
    const data = await makePatch(`/unidades/${id}/activar`);

    if (data.isFailure) return false;

    showSuccessToast('Registro activado');

    set({
      current: {
        ...get().current,
        activa: true
      }
    });

    return true;
  },
  desactivar: async (id: string) => {
    const data = await makePatch(`/unidades/${id}/desactivar`);

    if (data.isFailure) return false;

    showSuccessToast('Registro desactivado');

    set({
      current: {
        ...get().current,
        activa: false
      }
    });

    return true;
  }
}));
